import key from 'weak-key';

// types
import type { CountrySwitchPayload } from '../content-elements-payload';

// utils
import { genericLink } from 'components/Link/trackingActions';
import { useTracking } from 'utils/hooks/useTracking';
import { useCurrentLanguage } from 'utils/hooks/useCurrentLanguage';

interface CountrySwitchAccordionItemProps {
  countries: CountrySwitchPayload['region'][number]['country'];
  countryId?: number;
}

export function CountrySwitchAccordionItem({
  countries,
  countryId,
}: Readonly<CountrySwitchAccordionItemProps>) {
  const track = useTracking();
  const currentLang = useCurrentLanguage();
  countries.sort((a, b) => a.name.localeCompare(b.name));

  const hasLanguages = (country) => country.language.length > 1;
  const getLanguages = (country) => {
    if (hasLanguages(country)) {
      return (
        <ul className="country-switch-languages">
          {country.language.map((lang) => (
            <li
              key={key(lang)}
              className={`language-item ${
                lang.name.substr(0, 2) === currentLang ? 'currentLanguage' : 'selectable'
              }`}
            >
              <a href={lang.url} onClick={(e) => trackLink(e, lang, false)}>
                {lang.name.substr(0, 2)}
              </a>
            </li>
          ))}
        </ul>
      );
    }
    return null;
  };
  const trackLink = (e, country, isDefault) => {
    e.preventDefault();
    const countryName = isDefault ? 'Default' : country.name;
    track.trackEvent(genericLink('Links Worldwide', `${country.url} - ${countryName}`));

    // wait a bit so the event can be tracked
    setTimeout(() => {
      window.location.href = country.url;
    }, 200);
  };

  return (
    <div className="country-switch-accordion">
      <ul>
        {countries.map((country) => (
          <li key={key(country)} className={country.id === countryId ? 'currentCountry' : ''}>
            <a
              className={!hasLanguages(country) ? 'full-size' : undefined}
              href={country.language[0].url}
              onClick={(e) => trackLink(e, country.language[0], true)}
            >
              {country.name}
            </a>
            {getLanguages(country)}
          </li>
        ))}
      </ul>
    </div>
  );
}
